import React, { Component } from 'react';

export default class SelectionList extends Component {
    state = {
        selectedIndex: 0
    }

    constructor(props) {
        super(props);

        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    handleKeyDown(event) {
        if (!this.props.active) {
            return;
        }

        switch (event.which) {
            case 40: // Down
                this.selectionDown();

                this.attemptEventPrevent(event);
                break;

            case 38: // Up
                this.selectionUp();

                this.attemptEventPrevent(event);
                break;

            case 9: // Tab
            case 13: // Enter
                this.props.onSelect && this.props.onSelect(this.state.selectedIndex);

                this.attemptEventPrevent(event);
                break;

            default:
                return null;
        }
    }

    handleItemMouseEnter = index => {
        this.select(index);
    }

    selectionUp() {
        let index = this.state.selectedIndex - 1;

        if (index < 0) {
            index = this.props.children.length - 1;
        }

        this.select(index);
    }

    selectionDown() {
        let index = this.state.selectedIndex + 1;

        if (index >= this.props.children.length) {
            index = 0;
        }
        this.select(index);
    }

    select(index) {
        let selectedIndex = index;

        if (index < 0) {
            selectedIndex = 0;
        }

        if (index >= this.props.children.length) {
            if (this.props.children.length > 0) {
                selectedIndex = this.props.children.length - 1;
            } else {
                selectedIndex = 0;
            }
        }

        if (selectedIndex !== this.state.selectedIndex) {
            this.setState({ selectedIndex });
        }
    }

    attemptEventPrevent(event) {
        if (this.props.preventEvents) {
            event.preventDefault();
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate() {
        this.select(this.state.selectedIndex);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        return React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                selected: index === this.state.selectedIndex,
                index,
                onMouseEnter: this.handleItemMouseEnter
            });
        });
    }
}
